import React, { useEffect, useState } from 'react'
import { HeaderTable } from '../../HeaderTable'
import DataTable from 'react-data-table-component'
import axios from 'axios'
import { convertToIsraelTime } from '../../../util/formatsForDate'

const Used_day_via_member_spend = ({ row }) => {

    const [fetchData, setFetchData] = useState([])
    const [loading, setloading] = useState(true)
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1)
    const GET_URL = `admin/setting/used_day_via_member_spend/${row?.id}`
    const URL_EXCLE = `admin/setting/paying_customer/used_day_via_member_spend_excel/${row?.id}`


    const getDataTable = async (page) => {
        setloading(true)
        await axios.get(GET_URL, {
            params: {
                "page": page
                , "size": perPage,
            }
        })
            .then(response => {
                if (response.status == 200) {
                    setFetchData(response?.data)
                    // setdataForfilterScrach(response?.data)
                    setTotalRows(response.data.totalElements);
                }
            })
        setloading(false)

    }




    const handlePerRowsChange = async (newPerPage) => {
        setPerPage(newPerPage);

    }

    // const handleChange = (e) => {
    //     const { name, value } = e.target;
    //     setDataFillter({
    //         ...dataFillter,
    //         [name]: value
    //     });
    // }
    const handlePageChange = (page) => {
        // fetchUsers(page);
        // getData(page);
        setCurrentPage(page);
    };
    useEffect(() => {
        getDataTable(currentPage - 1)
    }, [])


    const columns = [

        {
            name: "קוד מוצר",
            // grow: 2,
            cell: (row) => row?.product_code,
            style: {
                fontSize: '10px',
                justifyContent: 'center',

                // width: '100px'
            },
             
        },


        {
            name: "שם מוצר",
            // grow: 3,
            cell: (row) => row?.product_name,
            style: {
                fontSize: '10px',
                justifyContent: 'center',
                // width: '100px'
            },
             


        },
        {
            name: "תאריך יום העיון",
            // grow: 3,
            cell: (row) => convertToIsraelTime(row?.qualification_startDate),
            style: {
                fontSize: '10px',
                justifyContent: 'center',
                // width: '100px'
            },
             
        },

        {
            name: "מספר יום העיון",
            cell: row => row?.qualification_number,

            style: {
                fontSize: '10px',
                justifyContent: 'center',

            },
            // grow: 3,


        },

        {
            name: "שם יום העיון",
            cell: row => row.qualification_name,

            style: {
                fontSize: '10px',
                justifyContent: 'center',

            },
            // grow: 2,


        },
        {
            name: "ת.ז.",
            cell: row => row.member_idNumber,

            style: {
                fontSize: '10px',
                justifyContent: 'center',

            },
            // grow: 2,


        },
        {
            name: "שם משפחה",
            cell: row => row?.member_lastName,

            style: {
                fontSize: '10px',
                justifyContent: 'center',

            },
            // grow: 2,


        },
        {
            name: "שם פרטי",
            cell: row => row?.member_firstName,

            style: {
                fontSize: '10px',
                justifyContent: 'center',

            },
            //grow: 2,


        },
        {
            name: "מספר חבר",
            cell: row => row?.member_number,

            style: {
                fontSize: '10px',
                justifyContent: 'center',

            },
            grow: 2,


        },



    ];



    const customStyles = {
        header: {
            style: {

                justifyContent: 'center',

            },
        },
        id: {
            style: {
                '&:2': { backgroundColor: '#EEEEEE' },
            }
        },
        headRow: {
            style: {
                justifyContent: 'center',
                borderTopStyle: 'solid',
                borderTopWidth: '1px',
                // borderTopColor: defaultThemes.default.divider.default,
            },
        },
        headCells: {
            style: {
                fontSize: '10px',
                justifyContent: 'center',
                borderRightStyle: 'solid',
                borderRightWidth: '1px',
                // borderRightColor: defaultThemes.default.divider.default,

            },
        },
        cells: {
            style: {
                '&:not(:last-of-type)': {

                    borderRightStyle: 'solid',
                    borderRightWidth: '1px',
                    // borderRightColor: defaultThemes.default.divider.default,
                },
            },
        },
        rows: {
            style: {
                backgroundColor: '#FFFFFF',
                '&:active': {
                    backgroundColor: '#EEEEEE',
                },
            },
        },
    }


    const downloadExcel = async () => {
        try {
            const response = await axios.get(URL_EXCLE, {
                // params: {
                //     ...dataFillter
                //   // member_number:"0001"
                // },
                responseType: 'blob', // הגדרת התגובה כ-blob לצורך הורדת הקובץ
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'report.xlsx');
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Error downloading file:', error);
        }

    }






    return (
        <div className='w-full p-3' style={{ direction: "ltr" }}>

            <HeaderTable active={"ימי עיון שנוצלו ע\"י הלקוח"} downloadExcel={downloadExcel}></HeaderTable>

            <DataTable columns={columns} data={fetchData} pagination
                customStyles={customStyles}
                paginationServer
                paginationTotalRows={totalRows}
                onChangeRowsPerPage={handlePerRowsChange}
                onChangePage={handlePageChange}
                progressPending={loading} className='border' >

            </DataTable>


        </div>

    )
}

export default Used_day_via_member_spend